import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationDataService } from '../../../../core/services/application-data.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-drop-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, MatButtonModule, TranslateModule, MatFormFieldModule, MatDialogModule],
  templateUrl: './drop-dialog.component.html',
  styleUrl: './drop-dialog.component.css'
})
export class DropDialogComponent {
  form: FormGroup;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<DropDialogComponent>,
      public dialog: MatDialog, private formBuilder: FormBuilder,
      private appDataService: ApplicationDataService,
      private authService: AuthenticationService
    ) {
  }
   ngOnInit() {
    this.form = this.formBuilder.group({
      complaintId: [this.data?.complaintId, [Validators.required]],
      segmentId: [this.authService.getUserSegment()],
      comment: [''],
    });
  }

  close(submitted: boolean = false) {
    this.dialogRef.close({ submitted });
  }

  drop() {

    if (this.form.invalid)
      return;

    this.appDataService.dropComplaint(this.form.value).subscribe(res => {
      this.close(true);
    })
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}
